<template>
  <v-row justify="end" align="start" no-gutters>
    <v-col cols="12" md="12" class="mr-4" style="text-align: end">
      <v-tooltip bottom v-if="twitter.show">
        <template v-slot:activator="{ on }">
          <v-btn
            outlined
            v-on="on"
            class="mx-1 my-2"
            color="indigo"
            dark
            :href="twitter.url"
            target="_blank"
          >
            <v-icon dark>mdi-twitter</v-icon>
          </v-btn>
        </template>
        <span>Our Twitter</span>
      </v-tooltip>

      <v-tooltip bottom v-if="facebook.show">
        <template v-slot:activator="{ on }">
          <v-btn
            outlined
            v-on="on"
            class="mx-1 my-2"
            color="indigo"
            dark
            :href="facebook.url"
            target="_blank"
          >
            <v-icon dark>mdi-facebook</v-icon>
          </v-btn>
        </template>
        <span>Our Facebook</span>
      </v-tooltip>

      <v-tooltip bottom v-if="instagram.show">
        <template v-slot:activator="{ on }">
          <v-btn
            outlined
            v-on="on"
            class="mx-1 my-2"
            color="indigo"
            dark
            :href="instagram.url"
            target="_blank"
          >
            <v-icon dark>mdi-instagram</v-icon>
          </v-btn>
        </template>
        <span>Our Instagram</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  computed: {
    twitter() {
      let object = {
        show: false,
        url: ""
      };

      console.log("-- Social Twitter");

      console.log(this.$store.getters.retrieveAllConfigs.social_twitter);

      if (this.$store.getters.retrieveAllConfigs.social_twitter) {
        object.url = this.$store.getters.retrieveAllConfigs.social_twitter;
        object.show = true;
      }

      return object;
    },
    facebook() {
      let object = {
        show: false,
        url: ""
      };

      if (this.$store.getters.retrieveAllConfigs.social_facebook) {
        object.url = this.$store.getters.retrieveAllConfigs.social_facebook;
        object.show = true;
      }

      return object;
    },
    instagram() {
      let object = {
        show: false,
        url: ""
      };

      if (this.$store.getters.retrieveAllConfigs.social_instagram) {
        object.url = this.$store.getters.retrieveAllConfigs.social_instagram;
        object.show = true;
      }

      return object;
    }
  }
};
</script>

<style lang="sass" scoped>
</style>